import ReactDOM from "react-dom/client";
import "./index.css";
import { createHashRouter, RouterProvider } from "react-router-dom";
import Layout from "./pages/layout/Layout.tsx";
import HomePage from "./pages/home_page/HomePage.tsx";
import Thoughts from "./pages/thoughts/Thoughts.tsx";
import ThoughtList from "./thought_list/ThoughtList.tsx";
import NoPage from "./pages/NoPage.tsx";
import UserLoginPage from "./pages/login/UserLoginPage.tsx";
import ResetPasswordPage from "./pages/login/ResetPasswordPage.tsx";
import UuidComponent from "./pages/login/UuidComponent.tsx";
import TermsPolicy from "./pages/privacy/TermsPolicy.tsx";
import LinkedInCallback from "./pages/login/LinkedInCallback.tsx";

const router = createHashRouter([
  {
    path: "/",
    children: [
      // UUID-based navigation route
      {
        path: "/",
        element: <Layout />,
        children: [
          {
            path: "/",
            element: <HomePage />
          },
          {
            path: "workbench",
            element: <HomePage />
          },
          {
            path: "interaction/:thought_id",
            element: <Thoughts prompt={""} response={""} citations={""} />
          },
          {
            path: "interactions",
            element: <ThoughtList />
          },
          {
            path: "terms&privacy-policy",
            element: <TermsPolicy />
          },
          {
            path: "change-password",
            element: <ResetPasswordPage />
          },
          {
            path: "*",
            element: <NoPage />
          }
        ]
      },
      {
        path: ":uuid",
        element: <UuidComponent></UuidComponent>
      },
      {
        path: "/login",
        element: <UserLoginPage></UserLoginPage>
      },
      {
        path: "/callback",
        element: <LinkedInCallback></LinkedInCallback>
      }
    ]
  }
]);

ReactDOM.createRoot(document.getElementById("root")!).render(<RouterProvider router={router} />);
